var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoreinfoHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_moreinfo_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_moreinfo_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F3F3F3",
    transform: "translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) ",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#5697B7",
    transform: "translate(8.000000, 9.000000) scale(-1, -1) rotate(90.000000) translate(-8.000000, -9.000000) ",
    points: "8 6 12 12 4 12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreinfoHover);
export default __webpack_public_path__ + "static/media/icon_moreinfo_hover.dd589aa691866660afe6dc15240167f0.svg";
export { ForwardRef as ReactComponent };